export default "__VITE_ASSET__CQhFr3ZY__"